import { Inject, Injectable } from '@angular/core';
import { UsersConfig, UsersConfigService } from '@modeso/aumico-lib-users-fe';

@Injectable({
    providedIn: 'root',
})
export class RoutesUtil {
    private readonly route = '/';
    private readonly apiGatewayUrl: string;
    private readonly tasks = 'tasks';
    private readonly annotations = 'annotations';
    private readonly projects = 'projects';

    constructor(@Inject(UsersConfigService) usersConfig: UsersConfig) {
        this.apiGatewayUrl = usersConfig.apiGateway;
    }

    public createAnnotation(taskId: string): string {
        return `${this.apiGatewayUrl}${this.tasks}${this.route}${taskId}${this.route}${this.annotations}`;
    }

    public updateAnnotation(annotationId: string): string {
        return `${this.apiGatewayUrl}${this.annotations}${this.route}${annotationId}`;
    }

    public deleteAnnotation(annotationId: string): string {
        return `${this.apiGatewayUrl}${this.annotations}${this.route}${annotationId}`;
    }

    public getTaskAnnotations(taskId: string): string {
        return `${this.apiGatewayUrl}${this.tasks}${this.route}${taskId}${this.route}${this.annotations}`;
    }
    /** REV-22155 — `personProject`: `/person-projects/:id/sync`. */
    public syncProjectWorkflow(projectId: string, personProject = false): string {
        return `${this.apiGatewayUrl}${personProject ? 'person-projects' : this.projects}/${projectId}/sync`;
    }
}
